export default __webpack_public_path__ + "static/doctor-2-fce4257703aa87a1f2bed21941454a82.png";